import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { ViewsModule } from './views/views.module';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { LayoutContainersModule } from './containers/layout/layout.containers.module';
import{CommonApiService} from 'src/app/shared/commonapi.service';
import{LoginService} from 'src/app/services/login.service';
import { MatTableModule  } from '@angular/material/table'; 
import { MatPaginatorModule  } from '@angular/material/paginator'; 
import {MatSortModule} from '@angular/material/sort';
import {  MatFormFieldModule,} from '@angular/material/form-field';
import {MatButtonModule} from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@NgModule({
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatButtonModule,
    BrowserModule,
    ViewsModule,
    AppRoutingModule,
    LayoutContainersModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    MatSelectModule,
    MatDatepickerModule,   
    FormsModule,
    NgSelectModule,
    FontAwesomeModule
  ],
  declarations: [
    AppComponent
  ],
  providers: [LoginService,CommonApiService],
  bootstrap: [AppComponent]
})
export class AppModule { }
